import { PRIMARY_COLOR } from '../../config/color';

export const AiTitleTriangle = () => (
  <svg viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M34 34V0L0 34H34Z" fill="#3309CD" />
  </svg>
);

export const AiTitleSquare = () => (
  <svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.166992" width="18.6667" height="18.6667" fill={PRIMARY_COLOR} />
  </svg>
);
export const AiKEYNOTESPEECH = () => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.78668 8.66667C5.57335 8.66667 5.38668 8.48 5.38668 8.26667V5.33333C5.38668 5.12 5.57335 4.93333 5.78668 4.93333C6.00002 4.93333 6.18668 5.12 6.18668 5.33333V8.26667C6.18668 8.48 6.00002 8.66667 5.78668 8.66667ZM10.2134 8.66667C10 8.66667 9.81335 8.48 9.81335 8.26667V6.8C9.81335 6.58667 10 6.4 10.2134 6.4C10.4267 6.4 10.6134 6.58667 10.6134 6.8V8.26667C10.6134 8.48 10.4534 8.66667 10.2134 8.66667ZM8.00002 8.66667C7.78668 8.66667 7.60002 8.48 7.60002 8.26667V7.52C7.60002 7.30667 7.78668 7.12 8.00002 7.12C8.21335 7.12 8.40002 7.30667 8.40002 7.52V8.26667C8.40002 8.48 8.21335 8.66667 8.00002 8.66667ZM14.6667 2.8H1.33335C1.12002 2.8 0.93335 2.61333 0.93335 2.4C0.93335 2.18667 1.12002 2 1.33335 2H14.6667C14.88 2 15.0667 2.18667 15.0667 2.4C15.0667 2.61333 14.88 2.8 14.6667 2.8Z"
      fill={PRIMARY_COLOR}
    />
    <path
      d="M12.4533 11.6H3.54665C2.50665 11.6 1.65332 10.7733 1.65332 9.73333V2.4C1.65332 2.18667 1.83999 2 2.05332 2C2.26665 2 2.47999 2.18667 2.47999 2.4V9.73333C2.47999 10.32 2.95999 10.8 3.57332 10.8H12.4533C13.04 10.8 13.5467 10.32 13.5467 9.73333V2.4C13.5467 2.18667 13.7333 2 13.9467 2C14.16 2 14.3467 2.18667 14.3467 2.4V9.73333C14.32 10.7733 13.4933 11.6 12.4533 11.6Z"
      fill={PRIMARY_COLOR}
    />
    <path
      d="M8.0001 14.5331C7.78676 14.5331 7.6001 14.3465 7.6001 14.1331V11.1998C7.6001 10.9865 7.78676 10.7998 8.0001 10.7998C8.21343 10.7998 8.4001 10.9865 8.4001 11.1998V14.1331C8.4001 14.3465 8.21343 14.5331 8.0001 14.5331Z"
      fill={PRIMARY_COLOR}
    />
    <path
      d="M10.2134 14.5334H5.78672C5.57339 14.5334 5.38672 14.3467 5.38672 14.1334C5.38672 13.9201 5.57339 13.7334 5.78672 13.7334H10.2401C10.4534 13.7334 10.6401 13.9201 10.6401 14.1334C10.6401 14.3467 10.4534 14.5334 10.2134 14.5334Z"
      fill={PRIMARY_COLOR}
    />
  </svg>
);

export const AiAIBooth = () => (
  <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_8566_3572)">
      <path
        d="M7.38883 0.0517578C11.7063 0.0517578 14.171 3.32387 13.9362 6.77954C13.7837 9.01954 12.8473 10.7026 11.4877 11.65C11.403 11.709 11.2984 11.7319 11.1968 11.7138C11.0952 11.6956 11.005 11.6378 10.946 11.5531C10.887 11.4685 10.8641 11.3638 10.8822 11.2622C10.9004 11.1606 10.9581 11.0704 11.0428 11.0114C12.2079 10.201 13.0238 8.73254 13.1599 6.72742C13.366 3.68709 11.2139 0.829536 7.38883 0.829536C5.10838 0.829536 3.07216 2.53287 2.41416 4.74409C2.35008 4.97984 2.3038 5.22007 2.27571 5.46276L2.23683 5.78787L2.20338 6.15576C2.19327 6.28487 2.18316 6.42176 2.1746 6.56487C2.17077 6.62339 2.15376 6.68029 2.12483 6.73131L2.09294 6.78031L1.02427 8.14531C0.988495 8.19098 0.963391 8.24408 0.950799 8.30071C0.938207 8.35735 0.938445 8.41608 0.951495 8.4726C0.964546 8.52913 0.990079 8.58202 1.02622 8.62741C1.06237 8.67278 1.10821 8.7095 1.16038 8.73487L1.22649 8.75976L2.48183 9.1082C2.54974 9.1269 2.61129 9.1637 2.65993 9.21465C2.70856 9.26561 2.74243 9.32882 2.75794 9.39754L2.76649 9.46909L2.8886 12.7941C2.89185 12.8829 2.92542 12.9679 2.98372 13.035C3.04203 13.1021 3.12155 13.1472 3.20905 13.1628L3.27671 13.1682H5.58438C5.68156 13.168 5.77529 13.2042 5.8471 13.2697C5.91892 13.3352 5.96361 13.4252 5.9724 13.522C5.98118 13.6187 5.9534 13.7153 5.89454 13.7926C5.83569 13.87 5.75001 13.9224 5.65438 13.9398L5.58438 13.946H3.27671C2.99372 13.946 2.72038 13.8431 2.50761 13.6565C2.29484 13.4699 2.15714 13.2123 2.12016 12.9318L2.11083 12.8229L1.9996 9.78098L1.01883 9.50876C0.739365 9.43135 0.498747 9.25265 0.343882 9.00748C0.189017 8.76231 0.131006 8.46826 0.181159 8.18265L0.206048 8.07376C0.237003 7.96294 0.28418 7.85732 0.346048 7.76031L0.411381 7.6662L1.40538 6.39454L1.41471 6.2732C1.46605 5.56231 1.53916 5.02098 1.6356 4.64298L1.66905 4.52242C2.42038 1.99698 4.74438 0.0517578 7.38883 0.0517578ZM9.75716 3.50354C9.95622 3.5034 10.152 3.55421 10.3259 3.65112C10.4998 3.74803 10.646 3.88782 10.7506 4.05718C10.8552 4.22655 10.9147 4.41987 10.9235 4.61874C10.9322 4.81761 10.89 5.01541 10.8007 5.19334C10.7115 5.37127 10.5782 5.5234 10.4135 5.63526C10.2488 5.74712 10.0583 5.81498 9.85999 5.8324C9.66169 5.84981 9.46223 5.8162 9.28059 5.73475C9.09896 5.65331 8.94118 5.52674 8.82227 5.36709L8.15571 5.74665C8.20471 6.01177 8.18435 6.28505 8.0966 6.53998L9.72683 7.51454C9.86903 7.4235 10.037 7.38122 10.2053 7.39406C10.3737 7.40691 10.5333 7.47419 10.6601 7.58575C10.7868 7.69731 10.8738 7.84708 10.9079 8.01244C10.942 8.1778 10.9214 8.34978 10.8492 8.50238C10.7769 8.65499 10.657 8.77995 10.5074 8.85837C10.3579 8.9368 10.1869 8.96443 10.0203 8.93711C9.85368 8.90979 9.70048 8.82898 9.58383 8.70691C9.46719 8.58483 9.39343 8.42811 9.37371 8.26042L9.3706 8.20754L7.66416 7.18942C7.43309 7.39645 7.14539 7.52965 6.83803 7.5719C6.53068 7.61416 6.21771 7.56355 5.93934 7.42656C5.66097 7.28958 5.42992 7.07249 5.27588 6.80318C5.12184 6.53388 5.05185 6.22466 5.0749 5.91527C5.09795 5.60588 5.21299 5.31045 5.40524 5.06695C5.59748 4.82344 5.85815 4.64298 6.15374 4.54876C6.44933 4.45454 6.76635 4.45086 7.06405 4.53819C7.36175 4.62553 7.62654 4.79989 7.82438 5.03887L8.59438 4.60176L8.59594 4.55742C8.62396 4.26888 8.75841 4.00111 8.97308 3.80628C9.18775 3.61146 9.46726 3.50353 9.75716 3.50354ZM6.6266 5.25354C6.52446 5.25352 6.42331 5.27363 6.32893 5.31271C6.23455 5.35179 6.1488 5.40908 6.07656 5.48131C6.00433 5.55353 5.94703 5.63928 5.90794 5.73365C5.86884 5.82802 5.84872 5.92917 5.84872 6.03131C5.84872 6.13346 5.86884 6.23461 5.90794 6.32898C5.94703 6.42335 6.00433 6.5091 6.07656 6.58132C6.1488 6.65355 6.23455 6.71083 6.32893 6.74992C6.42331 6.789 6.52446 6.8091 6.6266 6.80909C6.83287 6.80906 7.03067 6.72711 7.17651 6.58125C7.32235 6.43539 7.40428 6.23758 7.40428 6.03131C7.40428 5.82505 7.32235 5.62724 7.17651 5.48138C7.03067 5.33552 6.83287 5.25356 6.6266 5.25354ZM9.75794 4.28131C9.6548 4.28131 9.55588 4.32229 9.48295 4.39522C9.41002 4.46815 9.36905 4.56706 9.36905 4.6702C9.36905 4.77334 9.41002 4.87226 9.48295 4.94519C9.55588 5.01812 9.6548 5.05909 9.75794 5.05909C9.86108 5.05909 9.95999 5.01812 10.0329 4.94519C10.1059 4.87226 10.1468 4.77334 10.1468 4.6702C10.1468 4.56706 10.1059 4.46815 10.0329 4.39522C9.95999 4.32229 9.86108 4.28131 9.75794 4.28131Z"
        fill="#539FBF"
      />
    </g>
    <defs>
      <clipPath id="clip0_8566_3572">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AiLiveTime = () => (
  <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.2 4H3.8C3.35817 4 3 4.38802 3 4.86667V16.1333C3 16.612 3.35817 17 3.8 17H18.2C18.6418 17 19 16.612 19 16.1333V4.86667C19 4.38802 18.6418 4 18.2 4Z"
      stroke="#262626"
      stroke-width="1.13"
    />
    <path d="M7 2V6.5" stroke="#262626" stroke-width="1.13" />
    <path d="M19 8L3 8" stroke="#262626" stroke-width="1.13" />
    <path d="M15 2V6.5" stroke="#262626" stroke-width="1.13" />
  </svg>
);
export const shenyangComingSoon = () => (
  <svg viewBox="0 0 431 79" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M28.768 62.246C25.694 63.058 21.634 63.87 17.4 63.87C9.57 63.87 6.728 60.1 4.872 56.678C3.074 53.314 2.204 48.268 2.204 41.772C2.204 35.044 2.842 29.824 4.814 25.88C6.728 22.052 10.092 18.398 17.574 18.398C19.546 18.398 21.518 18.63 23.664 19.094C25.926 19.558 27.26 19.906 28.768 20.312V28.258C27.26 27.794 25.346 27.33 23.316 26.924C21.576 26.576 20.068 26.344 18.618 26.344C14.674 26.344 12.644 27.62 11.542 30.636C10.614 33.072 10.382 36.784 10.382 41.598C10.382 46.006 10.614 49.95 11.716 52.386C12.992 55.112 15.254 55.924 18.908 55.924C21.924 55.924 26.1 55.054 28.768 54.3V62.246ZM44.3011 31.506C49.4631 31.506 52.8851 33.42 54.6831 36.726C56.2491 39.568 56.8871 43.338 56.8871 47.572C56.8871 51.864 56.1331 55.866 54.6831 58.36C52.7111 61.898 49.8111 63.87 44.3011 63.87C38.6171 63.87 35.8331 62.072 33.8611 58.65C32.4691 56.272 31.6571 52.386 31.6571 47.804C31.6571 43.57 32.4691 39.394 33.8031 36.9C35.7751 33.246 39.0231 31.506 44.3011 31.506ZM44.3011 38.93C42.4451 38.93 41.2271 39.452 40.4731 41.308C39.8931 42.874 39.6031 45.078 39.6031 47.804C39.6031 50.298 39.7771 52.444 40.3571 53.952C41.1111 55.924 42.5031 56.446 44.3011 56.446C45.9251 56.446 47.1431 55.866 48.0131 54.184C48.7671 52.676 48.9411 50.472 48.9411 47.572C48.9411 44.962 48.6511 42.642 47.7811 40.902C47.0851 39.568 45.9831 38.93 44.3011 38.93ZM70.0382 63H62.2082V32.376H70.0382V34.058C71.0822 33.42 74.6202 31.506 77.2302 31.506C79.0862 31.506 80.3622 32.028 81.3482 33.072C81.9282 33.652 82.2182 34.174 82.5082 34.754C84.4222 33.478 87.6702 31.506 90.5122 31.506C92.7162 31.506 94.6302 32.086 95.9642 33.826C97.4722 35.856 98.2262 38.872 98.2262 44.962V63H90.3962V45.078C90.3962 43.048 90.3962 41.308 89.8742 40.322C89.4682 39.568 88.8302 39.51 88.1342 39.51C87.0322 39.51 84.8862 40.844 84.1322 41.366V63H76.3022V45.078C76.3022 43.048 76.3022 41.308 75.9542 40.438C75.5482 39.568 74.8522 39.51 74.2142 39.51C73.1702 39.51 70.9662 40.786 70.0382 41.366V63ZM112.235 63H104.405V32.376H112.235V63ZM112.235 28.2H104.405V19.268H112.235V28.2ZM126.339 63H118.509V32.376H126.339V34C128.659 32.782 131.617 31.506 134.285 31.506C136.373 31.506 138.229 32.028 139.505 33.768C141.013 35.798 141.535 39.22 141.535 44.962V63H133.705V45.078C133.705 42.7 133.647 41.25 133.183 40.38C132.719 39.626 132.023 39.51 131.153 39.51C129.819 39.51 127.267 40.902 126.339 41.424V63ZM147.91 74.194V67.002C149.824 67.35 153.246 67.872 156.784 67.872C159.162 67.872 160.844 67.408 161.83 66.306C162.816 65.204 163.222 63.522 163.222 61.608V60.448C162.584 60.854 161.83 61.26 161.018 61.666C159.684 62.362 157.944 62.884 155.74 62.884C152.666 62.884 150.23 61.144 148.896 58.592C147.562 56.098 146.866 52.618 146.866 47.746C146.866 43.048 147.504 39.104 148.838 36.494C150.694 33.014 153.362 31.506 158.698 31.506C162.816 31.506 167.05 33.13 171.052 34.754V59.23C171.052 64.16 170.762 68.046 168.616 70.888C166.528 73.672 162.758 75.006 156.784 75.006C153.188 75.006 150.462 74.6 147.91 74.194ZM163.222 53.372V39.916C161.656 39.278 160.38 38.93 159.104 38.93C157.306 38.93 155.914 39.626 155.392 41.424C154.928 42.874 154.812 44.962 154.812 47.746C154.812 49.892 154.928 51.632 155.334 53.256C155.798 54.938 156.784 55.46 158.292 55.46C159.452 55.46 160.496 54.996 161.366 54.474C162.12 54.068 162.7 53.72 163.222 53.372ZM188.215 62.072V54.01C192.101 54.996 197.089 56.098 201.091 56.098C203.701 56.098 205.267 55.75 206.253 54.822C207.181 53.952 207.471 52.618 207.471 51.11C207.471 49.718 207.007 48.732 206.311 48.036C205.615 47.34 204.165 46.528 202.309 45.716L196.567 43.106C194.131 42.004 192.623 41.192 191.173 39.858C188.853 37.77 187.867 34.812 187.867 30.984C187.867 26.228 189.027 23.328 191.811 20.95C194.189 18.92 197.669 18.398 201.381 18.398C205.499 18.398 211.125 19.732 214.083 20.602V28.49C210.951 27.62 204.513 26.17 201.381 26.17C199.235 26.17 197.901 26.46 197.089 27.388C196.335 28.258 196.045 29.36 196.045 30.694C196.045 32.202 196.335 33.188 197.031 33.884C197.785 34.638 198.539 35.044 200.395 35.856L206.137 38.466C208.631 39.626 210.719 40.612 212.285 42.062C214.373 43.976 215.649 47.05 215.649 50.82C215.649 54.996 214.605 58.012 211.995 60.506C209.443 62.942 206.543 63.87 201.091 63.87C197.147 63.87 191.637 62.884 188.215 62.072ZM232.461 31.506C237.623 31.506 241.045 33.42 242.843 36.726C244.409 39.568 245.047 43.338 245.047 47.572C245.047 51.864 244.293 55.866 242.843 58.36C240.871 61.898 237.971 63.87 232.461 63.87C226.777 63.87 223.993 62.072 222.021 58.65C220.629 56.272 219.817 52.386 219.817 47.804C219.817 43.57 220.629 39.394 221.963 36.9C223.935 33.246 227.183 31.506 232.461 31.506ZM232.461 38.93C230.605 38.93 229.387 39.452 228.633 41.308C228.053 42.874 227.763 45.078 227.763 47.804C227.763 50.298 227.937 52.444 228.517 53.952C229.271 55.924 230.663 56.446 232.461 56.446C234.085 56.446 235.303 55.866 236.173 54.184C236.927 52.676 237.101 50.472 237.101 47.572C237.101 44.962 236.811 42.642 235.941 40.902C235.245 39.568 234.143 38.93 232.461 38.93ZM262.084 31.506C267.246 31.506 270.668 33.42 272.466 36.726C274.032 39.568 274.67 43.338 274.67 47.572C274.67 51.864 273.916 55.866 272.466 58.36C270.494 61.898 267.594 63.87 262.084 63.87C256.4 63.87 253.616 62.072 251.644 58.65C250.252 56.272 249.44 52.386 249.44 47.804C249.44 43.57 250.252 39.394 251.586 36.9C253.558 33.246 256.806 31.506 262.084 31.506ZM262.084 38.93C260.228 38.93 259.01 39.452 258.256 41.308C257.676 42.874 257.386 45.078 257.386 47.804C257.386 50.298 257.56 52.444 258.14 53.952C258.894 55.924 260.286 56.446 262.084 56.446C263.708 56.446 264.926 55.866 265.796 54.184C266.55 52.676 266.724 50.472 266.724 47.572C266.724 44.962 266.434 42.642 265.564 40.902C264.868 39.568 263.766 38.93 262.084 38.93ZM287.821 63H279.991V32.376H287.821V34C290.141 32.782 293.099 31.506 295.767 31.506C297.855 31.506 299.711 32.028 300.987 33.768C302.495 35.798 303.017 39.22 303.017 44.962V63H295.187V45.078C295.187 42.7 295.129 41.25 294.665 40.38C294.201 39.626 293.505 39.51 292.635 39.51C291.301 39.51 288.749 40.902 287.821 41.424V63Z"
      fill="url(#paint0_linear_8566_6012)"
    />
    <rect x="336" y="30.5" width="18" height="18" fill="#572DF3" />
    <rect
      x="383.5"
      y="30"
      width="13.4352"
      height="13.4352"
      transform="rotate(45 383.5 30)"
      fill={PRIMARY_COLOR}
    />
    <rect
      x="431"
      y="30.5"
      width="18"
      height="18"
      rx="9"
      transform="rotate(90 431 30.5)"
      fill="#0E45B0"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8566_6012"
        x1="301.058"
        y1="63.2"
        x2="-19.7851"
        y2="5.75178"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color={PRIMARY_COLOR} />
        <stop offset="1" stop-color="#FF19B4" />
      </linearGradient>
    </defs>
  </svg>
);
export const AiOpenDaySwiperLeft = () => (
  <svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.9079 16.8417L9.38159 11.3154L14.9079 5.78906"
      stroke="black"
      stroke-width="2"
      stroke-linecap="square"
    />
  </svg>
);
export const AiOpenDaySwiperRight = () => (
  <svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.09209 16.8417L13.6184 11.3154L8.09209 5.78906"
      stroke="black"
      stroke-width="2"
      stroke-linecap="square"
    />
  </svg>
);
export const openday2021SVG = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="31.7355" cy="32" rx="31.7355" ry="32" fill="#EEF0F4" />
    <path
      d="M44.126 18.5H21.626C20.3833 18.5 19.376 19.5074 19.376 20.75V43.25C19.376 44.4927 20.3833 45.5 21.626 45.5H44.126C45.3687 45.5 46.376 44.4927 46.376 43.25V20.75C46.376 19.5074 45.3687 18.5 44.126 18.5Z"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M24.9558 36.3759L29.1985 32.1333L32.4895 35.4166L40.376 27.5"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M34.376 27.5H40.376V33.5"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const openday2022SVG = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="32.124" cy="32" rx="31.7355" ry="32" fill="#EEF0F4" />
    <path
      d="M42.537 23V29V29.75C40.3389 29.75 38.3636 30.7113 37.002 32.2398C35.8188 33.5679 35.0989 35.3242 35.0989 37.25C35.0989 37.6842 35.1355 38.1097 35.2057 38.5237C35.5883 40.7784 36.9691 42.6897 38.8731 43.7785C36.8927 44.3822 34.2641 44.75 31.3799 44.75C25.218 44.75 20.2229 43.071 20.2229 41V35V29V23"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linecap="square"
    />
    <path
      d="M42.537 23C42.537 25.071 37.5418 26.75 31.3799 26.75C25.218 26.75 20.2229 25.071 20.2229 23C20.2229 20.9289 25.218 19.25 31.3799 19.25C37.5418 19.25 42.537 20.9289 42.537 23Z"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linecap="square"
    />
    <path
      d="M20.2229 35C20.2229 37.071 25.218 38.75 31.3799 38.75C32.724 38.75 34.0125 38.6701 35.2057 38.5237"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linecap="square"
    />
    <path
      d="M20.2229 29C20.2229 31.071 25.218 32.75 31.3799 32.75C33.4301 32.75 35.3511 32.5641 37.0019 32.2398"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linecap="square"
    />
    <path
      d="M49.9752 37.25C49.9752 41.3921 46.645 44.75 42.5371 44.75C41.2051 44.75 39.9547 44.3969 38.8732 43.7785C36.9693 42.6897 35.5885 40.7784 35.2059 38.5237C35.1357 38.1097 35.0991 37.6842 35.0991 37.25C35.0991 35.3242 35.819 33.5679 37.0021 32.2398C38.3638 30.7113 40.3391 29.75 42.5371 29.75C46.645 29.75 49.9752 33.1079 49.9752 37.25Z"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linecap="square"
    />
    <path
      d="M44.7686 35.75L46.2562 37.25L44.7686 38.75"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linecap="square"
    />
    <path
      d="M40.3057 38.75L38.8181 37.25L40.3057 35.75"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linecap="square"
    />
  </svg>
);
export const openday2023SVG = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="32.0495" cy="32" rx="31.7355" ry="32" fill="#EEF0F4" />
    <path
      d="M30.5618 20V29C30.5618 30.6568 27.5647 32 23.8676 32C20.1704 32 17.1733 30.6568 17.1733 29V20"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M30.5618 24.5C30.5618 26.1568 27.5647 27.5 23.8676 27.5C20.1704 27.5 17.1733 26.1568 17.1733 24.5"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M30.5618 20C30.5618 21.6568 27.5647 23 23.8676 23C20.1704 23 17.1733 21.6568 17.1733 20C17.1733 18.3431 20.1704 17 23.8676 17C27.5647 17 30.5618 18.3431 30.5618 20Z"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M46.9255 35V44C46.9255 45.6568 43.9285 47 40.2313 47C36.5342 47 33.5371 45.6568 33.5371 44V35"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M46.9255 39.5C46.9255 41.1568 43.9285 42.5 40.2313 42.5C36.5342 42.5 33.5371 41.1568 33.5371 39.5"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M46.9255 35C46.9255 36.6568 43.9285 38 40.2313 38C36.5342 38 33.5371 36.6568 33.5371 35C33.5371 33.3432 36.5342 32 40.2313 32C43.9285 32 46.9255 33.3432 46.9255 35Z"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M38 18.5H42.4628C44.1059 18.5 45.438 19.8431 45.438 21.5V26"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M26.0991 45.5H21.6363C19.9932 45.5 18.6611 44.1568 18.6611 42.5V38"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const openday2025SVG = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="31.7355" cy="32" rx="31.7355" ry="32" fill="currentColor" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.7358 47.75C34.1313 47.75 38.2272 44.6 38.2272 32C38.2272 19.4 34.1313 16.25 31.7358 16.25C29.3404 16.25 25.2444 19.6123 25.2444 32C25.2444 44.3878 29.3404 47.75 31.7358 47.75Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.6815 40.2495C18.8793 42.3587 23.7381 44.3153 34.9815 37.7153C46.2248 31.1153 46.9877 25.8587 45.79 23.7495C44.5922 21.6403 39.544 19.7949 28.4901 26.2838C17.4361 32.7725 16.4838 38.1403 17.6815 40.2495Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.6814 23.7495C16.4837 25.8587 17.2466 31.1153 28.49 37.7153C39.7334 44.3153 44.5921 42.3587 45.7898 40.2495C46.9876 38.1403 46.0353 32.7725 34.9813 26.2838C23.9274 19.7949 18.8792 21.6403 17.6814 23.7495Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const opendaygline = () => (
  <svg height="12" viewBox="0 0 272 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M271.333 6C271.333 3.05448 268.946 0.666667 266 0.666667C263.054 0.666666 260.667 3.05448 260.667 6C260.667 8.94552 263.054 11.3333 266 11.3333C268.946 11.3333 271.333 8.94552 271.333 6ZM11.3333 5.99998C11.3333 3.05446 8.94553 0.666644 6 0.666644C3.05447 0.666644 0.666657 3.05446 0.666656 5.99998C0.666656 8.9455 3.05447 11.3333 6 11.3333C8.94553 11.3333 11.3333 8.9455 11.3333 5.99998ZM266 5L264.03 5L264.03 7L266 7L266 5ZM260.091 5L256.152 5L256.152 7L260.091 7L260.091 5ZM252.212 5L248.273 5L248.273 7L252.212 7L252.212 5ZM244.333 5L240.394 5L240.394 7L244.333 7L244.333 5ZM236.455 5L232.515 5L232.515 7L236.455 7L236.455 5ZM228.576 5L224.636 5L224.636 7L228.576 7L228.576 5ZM220.697 5L216.758 5L216.758 7L220.697 7L220.697 5ZM212.818 5L208.879 5L208.879 7L212.818 7L212.818 5ZM204.939 4.99999L201 4.99999L201 6.99999L204.939 6.99999L204.939 4.99999ZM197.061 4.99999L193.121 4.99999L193.121 6.99999L197.061 6.99999L197.061 4.99999ZM189.182 4.99999L185.242 4.99999L185.242 6.99999L189.182 6.99999L189.182 4.99999ZM181.303 4.99999L177.364 4.99999L177.364 6.99999L181.303 6.99999L181.303 4.99999ZM173.424 4.99999L169.485 4.99999L169.485 6.99999L173.424 6.99999L173.424 4.99999ZM165.545 4.99999L161.606 4.99999L161.606 6.99999L165.545 6.99999L165.545 4.99999ZM157.667 4.99999L153.727 4.99999L153.727 6.99999L157.667 6.99999L157.667 4.99999ZM149.788 4.99999L145.849 4.99999L145.849 6.99999L149.788 6.99999L149.788 4.99999ZM141.909 4.99999L137.97 4.99999L137.97 6.99999L141.909 6.99999L141.909 4.99999ZM134.03 4.99999L130.091 4.99999L130.091 6.99999L134.03 6.99999L134.03 4.99999ZM126.152 4.99999L122.212 4.99999L122.212 6.99999L126.152 6.99999L126.152 4.99999ZM118.273 4.99999L114.333 4.99999L114.333 6.99999L118.273 6.99999L118.273 4.99999ZM110.394 4.99999L106.455 4.99999L106.455 6.99999L110.394 6.99999L110.394 4.99999ZM102.515 4.99999L98.5758 4.99999L98.5758 6.99999L102.515 6.99999L102.515 4.99999ZM94.6364 4.99999L90.697 4.99998L90.697 6.99998L94.6364 6.99999L94.6364 4.99999ZM86.7576 4.99998L82.8183 4.99998L82.8183 6.99998L86.7576 6.99998L86.7576 4.99998ZM78.8789 4.99998L74.9395 4.99998L74.9395 6.99998L78.8789 6.99998L78.8789 4.99998ZM71.0001 4.99998L67.0607 4.99998L67.0607 6.99998L71.0001 6.99998L71.0001 4.99998ZM63.1213 4.99998L59.1819 4.99998L59.1819 6.99998L63.1213 6.99998L63.1213 4.99998ZM55.2425 4.99998L51.3031 4.99998L51.3031 6.99998L55.2425 6.99998L55.2425 4.99998ZM47.3637 4.99998L43.4243 4.99998L43.4243 6.99998L47.3637 6.99998L47.3637 4.99998ZM39.4849 4.99998L35.5455 4.99998L35.5455 6.99998L39.4849 6.99998L39.4849 4.99998ZM31.6062 4.99998L27.6668 4.99998L27.6668 6.99998L31.6062 6.99998L31.6062 4.99998ZM23.7274 4.99998L19.788 4.99998L19.788 6.99998L23.7274 6.99998L23.7274 4.99998ZM15.8486 4.99998L11.9092 4.99998L11.9092 6.99998L15.8486 6.99998L15.8486 4.99998ZM7.96979 4.99998L6 4.99998L6 6.99998L7.96979 6.99998L7.96979 4.99998Z"
      fill="url(#paint0_linear_8566_3171)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8566_3171"
        x1="266"
        y1="5.5"
        x2="6"
        y2="5.49998"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color={PRIMARY_COLOR} />
        <stop offset="1" stop-color="#9E9E9E" />
      </linearGradient>
    </defs>
  </svg>
);
export const AiTitleSquare45 = () => (
  <svg viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="10.6992"
      y="0.800781"
      width="15.1311"
      height="15.1311"
      transform="rotate(45 10.6992 0.800781)"
      fill={PRIMARY_COLOR}
    />
  </svg>
);

export const OBJECTIVES_SVG4 = () => (
  <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.85156 9.93262H21.8516V20.4326C21.8516 20.9849 21.4039 21.4326 20.8516 21.4326H3.85156C3.29928 21.4326 2.85156 20.9849 2.85156 20.4326V9.93262Z"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M2.85156 4.93262C2.85156 4.38033 3.29928 3.93262 3.85156 3.93262H20.8516C21.4039 3.93262 21.8516 4.38033 21.8516 4.93262V9.93262H2.85156V4.93262Z"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M8.35156 2.43262V6.43262"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.3516 2.43262V6.43262"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.3516 17.4326H17.3516"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.35156 17.4326H10.3516"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.3516 13.4326H17.3516"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.35156 13.4326H10.3516"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const OBJECTIVES_SVG5 = () => (
  <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.92893 16.7715C3.11929 17.3144 2 18.0644 2 18.8928C2 20.5496 6.47715 21.8928 12 21.8928C17.5229 21.8928 22 20.5496 22 18.8928C22 18.0644 20.8807 17.3144 19.0711 16.7715"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 17.8926C12 17.8926 18.5 13.6446 18.5 8.73348C18.5 5.2315 15.5898 2.39258 12 2.39258C8.41015 2.39258 5.5 5.2315 5.5 8.73348C5.5 13.6446 12 17.8926 12 17.8926Z"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M12 11.3926C13.3807 11.3926 14.5 10.2733 14.5 8.89258C14.5 7.51188 13.3807 6.39258 12 6.39258C10.6193 6.39258 9.5 7.51188 9.5 8.89258C9.5 10.2733 10.6193 11.3926 12 11.3926Z"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
);
export const OBJECTIVES_SVG6 = () => (
  <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.3469 10.4014C12.2799 10.4014 13.8469 8.83437 13.8469 6.90137C13.8469 4.96837 12.2799 3.40137 10.3469 3.40137C8.41392 3.40137 6.84692 4.96837 6.84692 6.90137C6.84692 8.83437 8.41392 10.4014 10.3469 10.4014Z"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.1509 3.90137C18.1673 4.51382 18.8471 5.62822 18.8471 6.90137C18.8471 8.17452 18.1673 9.28892 17.1509 9.90137"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.84692 20.8014V21.4014H17.8469V20.8014C17.8469 18.5612 17.8469 17.4411 17.411 16.5854C17.0275 15.8328 16.4155 15.2208 15.6629 14.8373C14.8072 14.4014 13.6871 14.4014 11.4469 14.4014H9.24692C7.00672 14.4014 5.88662 14.4014 5.03096 14.8373C4.27831 15.2208 3.66639 15.8328 3.2829 16.5854C2.84692 17.4411 2.84692 18.5612 2.84692 20.8014Z"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.8469 21.4019V20.8019C22.8469 18.5617 22.8469 17.4416 22.4109 16.5859C22.0274 15.8333 21.4155 15.2214 20.6628 14.8379"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
